module.exports = __webpack_public_path__ + "img/logowiz-small.f01ca693.png";